export enum Size {
    Sm = 'sm',
    Md = 'md',
    Lg = 'lg',
    Xl = 'xl',
    Form = 'form',
    FullScreen = 'fullScreen',
    Dynamic = 'dynamic'
}

export enum Backdrop {
    Static = 'static'
}

export enum Position {
    Top = 'top',
    Center = 'center',
    Bottom = 'bottom'
}

export enum Layer {
    Back = 'back',
    Front = 'front'
}

export interface ModalOptions {
    size: Size;
    backdrop?: Backdrop;
    position?: Position;
    layer?: Layer;
    showCancelButton?: boolean;
}
